import { GetterTree } from 'vuex'
import NetsuiteData from '../types/NetsuiteData'

export const getters: GetterTree<NetsuiteData, any> = {
  getCustomer: state => state.customer,
  getBrandManager: state => (state.customer && state.customer.employee) || null,
  getBrandManagerName: state => {
    const employee = state.customer && state.customer.employee
    if (!employee) return ''
    return [employee.first_name, employee.last_name].filter(Boolean).join(' ')
  },
  getBrandManagerEmail: state => {
    const employee = state.customer && state.customer.employee
    return (employee && employee.email) || ''
  },
  getOrders: state => state.orders || [],
  getOrderSummaries: state => (state.orderSummaries && state.orderSummaries.orders) || [],
  getOrderSummariesPage: state => state.orderSummaries,
  getOrderSummariesPagination: state => (state.orderSummaries && state.orderSummaries.pagination) || null,
  getCurrentOrder: state => state.currentOrder,
  getOrderItems: state => state.orderItems || [],
  getTracking: state => state.tracking || [],
  isLoading: state => state.loading,
  isSubmitting: state => state.submitting,
  getError: state => state.error
}
